import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { createBrowserHistory } from 'history';
import configureStore from './configureStore.js';
import App from './containers/App.jsx';

function renderToElement(elementId, scroll_coordinates) {
  const store = configureStore();
  const history = createBrowserHistory();

  const container = document.getElementById(elementId);
  if (!container) return null;
  window.__explorer_roots = window.__explorer_roots || {};
  if (!window.__explorer_roots[elementId]) {
    window.__explorer_roots[elementId] = createRoot(container);
  }
  window.__explorer_roots[elementId].render(
    <Provider store={store} key="provider">
      <App history={history} scroll_coordinates={scroll_coordinates}/>
    </Provider>
  );
}

export default renderToElement;
window.Explorer = {
  render: renderToElement,
};
